import React, { useState, useEffect } from "react";
import { InputBox, Input } from "../components";
import { validate } from "../constants";
import Context from "../Context";
import ReCAPTCHA from "react-google-recaptcha";
import { Collapse } from "reactstrap";

export const VerifyCart = () => {
  const { callApi, go, cart } = Context();
  const recaptchaRef = React.useRef();
  const [phone, setPhone] = useState("");
  const [token, setToken] = useState("");

  const [otpRef, setOtpRef] = useState("");
  const [digits, setDigits] = useState(["", "", "", "", "", ""]);
  const [expireIn, setExpireIn] = useState(0);
  const [attempt, setAttempt] = useState(1);

  useEffect(() => {
    const countDown = setInterval(() => {
      if (expireIn > 0) {
        setExpireIn((x) => {
          if (x >= 1000) {
            return x - 1000;
          } else {
            setOtpRef("");
            setDigits([]);
            setExpireIn(0);
            setAttempt(0);
            return;
          }
        });
      } else {
        return () => clearInterval(countDown);
      }
    }, 1000);

    return () => clearInterval(countDown);
  }, [expireIn > 0]);

  useEffect(() => {
    getCart();

    onSubmitWithReCAPTCHA();
  }, []);

  const getCart = async () => {
    const result = await callApi(
      "utils-calculatePrice",
      { guestId: localStorage.guestId },
      { notShowLoading: true }
    );
    if (result.otp.expireAt > Date.now() && result.otp.attempt <= 3) {
      setExpireIn(result.otp.expireAt - Date.now());
      setOtpRef(result.otp.otpRef);
    } else {
      setExpireIn(0);
    }
    if (result.otp.status) {
      return go("/cart");
    }
    if (result.totalSize === 0 || !result) {
      return go("/");
    }
  };

  const onSubmitWithReCAPTCHA = async () => {
    const token = recaptchaRef.current.getValue();
    setToken(token);
  };
  const requestOTP = async () => {
    // if (!token) return;
    const tempOtpRef = Math.floor(Math.random() * 60466175)
      .toString(36)
      .toUpperCase()
      .padStart(5, "0");

    const result = await callApi("carts-sendCartOTP", {
      phone,
      guestId: localStorage.guestId,
      otpRef: tempOtpRef,
      reCaptchaToken: token,
    });
    setOtpRef(result.otpRef);
    setExpireIn(result.expireAt - Date.now());
  };

  const submitOTP = async () => {
    const result = await callApi("carts-verifyCartOTP", {
      guestId: localStorage.guestId,
      otp: digits.join(""),
      otpRef,
    });

    if (result.status) {
      if (result.accessToken) {
        localStorage.setItem("accessToken", result.accessToken);
        window.location.reload();
      } else {
        go("/cart");
      }
    }
    if (result.data.attempt) {
      setAttempt(result.data.attempt);
    }
  };

  const cancelCartOTP = async () => {
    const result = await callApi("carts-cancelCartOTP", {
      guestId: localStorage.guestId,
      otpRef,
    });

    if (result.status) {
      setOtpRef("");
      setDigits([]);
      setExpireIn(0);
      setAttempt(0);
    }
  };

  const CountDownText = ({ second = 0 }) => {
    if (second <= 0) return <span>00:00</span>;
    second = parseInt(second / 1000);
    const pattern =
      String(Math.floor(second / 60)).padStart(2, "0") +
      ":" +
      String(second % 60).padStart(2, "0");
    return <span>{pattern}</span>;
  };

  return (
    <div className="w-full mb-16">
      {/* <ProgressBar status={1} /> */}
      <div className="w-full px-3">
        <div className="w-full max-w-[400px] bg-white mt-4 p-3 rounded-md mx-auto shadow-md">
          <img
            src="/images/otp.svg"
            alt="otp"
            className="w-full max-w-72 mx-auto"
          />
          <Collapse
            className="flex flex-col items-center"
            isOpen={expireIn < 1}
          >
            <p className="text-xl text-gray-500 mt-6 text-center font-semibold">
              โปรดยืนยันหมายเลขโทรศัพท์
            </p>
            <div className="w-full">
              <p className="text-sm text-gray-500 mt-3">
                เบอร์โทรศัพท์<span className="text-red-500">*</span>
              </p>

              <input
                className="border-2 border-gray-300 font-semibold rounded-md p-2 w-full disabled:bg-slate-100 disabled:text-slate-600 disabled:cursor-not-allowed"
                placeholder="09X-XXX-XXXX"
                value={phone}
                type="input"
                onChange={(e) => {
                  if (validate.digitOnly.test(e.target.value)) {
                    setPhone(e.target.value);
                  }
                }}
              />
            </div>
            <div className="relative flex justify-center items-cente my-3 w-full">
              <form className="" onSubmit={onSubmitWithReCAPTCHA}>
                <ReCAPTCHA
                  // size="invisible"
                  ref={recaptchaRef}
                  sitekey="6LepvVYqAAAAAOZudU8U6HwAe1h2AFpxtQCx7R0i"
                  onChange={() => onSubmitWithReCAPTCHA()}
                />
              </form>
            </div>

            <button
              className="px-4 h-10 w-full bg-[#003A9E] disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-700 hover:opacity-90 text-white text-sm font-semibold rounded-md"
              disabled={phone.length < 9 || !token}
              onClick={() => requestOTP()}
            >
              ยืนยันด้วย OTP
            </button>
          </Collapse>
          <Collapse isOpen={expireIn > 0}>
            <p className="text-xl text-gray-500 mt-6 text-center font-semibold">
              ยืนยันรหัส OTP
            </p>
            <p className="my-1 text-center">
              รหัสอ้างอิง:{" "}
              <span className="font-bold text-[#003A9E]">{otpRef}</span>
            </p>
            <p className="my-1 text-center">
              หมดอายุภายใน{" "}
              <span className="font-bold text-[#003A9E]">
                <CountDownText second={expireIn} />
              </span>
            </p>
            <div className="flex justify-center items-center my-3 w-full">
              <InputBox
                digits={digits}
                setDigits={setDigits}
                action={submitOTP}
                gap="5px"
              />
            </div>
            <button
              className="px-4 h-10 w-full my-2 bg-[#003A9E] disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-700 hover:opacity-90 text-white text-sm font-semibold rounded-md"
              disabled={digits.length !== 6}
              onClick={() => submitOTP()}
            >
              ยืนยัน
            </button>
            <p
              className="px-4 h-10 w-full hover:opacity-90 mt-3 text-center text-red-500 text-sm font-semibold rounded-md cursor-pointer"
              disabled={digits.length !== 6}
              onClick={() => cancelCartOTP()}
            >
              ยกเลิก
            </p>
          </Collapse>
        </div>
      </div>
    </div>
  );
};
